var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const getErrorMessage = (response) => __awaiter(void 0, void 0, void 0, function* () {
    const text = yield response.text();
    if (text)
        return text;
    return `Request failed with status ${response.status}`;
});
export class RequestError extends Error {
    constructor(message, status) {
        super(message);
        this.name = "RequestError";
        this.status = status;
    }
}
export const request = (input, init) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(input, Object.assign({ credentials: "same-origin" }, init));
    if (!response.ok) {
        throw new RequestError(yield getErrorMessage(response), response.status);
    }
    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
        return yield response.json();
    }
    const text = yield response.text();
    if (text.length === 0) {
        return undefined;
    }
    throw new Error("Unknown response object");
});
